import { cn } from '@/lib/cn';
import { defaultNS, useTranslation } from '@/lib/i18n';
import type { Props } from '../types';
import { FallbackDisplay } from './FallbackDisplay';
import { TableStructure } from './TableStructure';
import { useTableInteraction } from './useTableInteraction';
const DEFAULT_SKELETON_ROWS = 10;
const MIN_SKELETON_ROWS = 5;
export default function DataTable<TData>({
  table,
  displayState,
  className,
  rootClassName,
  onRowClick,
  isHoverable
}: Props<TData>) {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'component.dataTable'
  });

  // テーブルインタラクション（スクロール、クリック）の管理
  const {
    containerRef,
    handleRowClick
  } = useTableInteraction({
    onRowClick
  });

  // 行クリックの機能があるかどうか
  const isClickable = onRowClick !== null;

  // プレースホルダー表示の場合
  if (displayState.state === 'placeholder') {
    return <FallbackDisplay content={displayState.content} defaultMessage={t('placeholder')} rootClassName={rootClassName} />;
  }

  // 空状態表示の場合
  if (displayState.state === 'empty') {
    return <FallbackDisplay content={displayState.content} defaultMessage={t('noResult')} rootClassName={rootClassName} />;
  }

  // スケルトンローディング表示時のスケルトン行数を決定
  const skeletonRowCount = displayState.state === 'loading' ? Math.max(table.getState().pagination.pageSize || DEFAULT_SKELETON_ROWS, MIN_SKELETON_ROWS) : 0;
  return <div ref={containerRef} data-scrolling="false" className={cn('group/table-container h-full overflow-auto rounded-md bg-neutral-fill', rootClassName)}>
      <TableStructure table={table} className={className} onRowClick={handleRowClick} isHoverable={isHoverable} isClickable={isClickable} isLoading={displayState.state === 'loading'} skeletonRowCount={skeletonRowCount} />
    </div>;
}